import React, { useState } from 'react';
import propTypes from 'prop-types';
import cn from 'classnames';
import AddToFolder from '~/Components/Global/Assets/Svgs/AddToFolder';
import PinIcon from '../../../Global/Assets/Svgs/PinIcon';

const PinnedListOption = ({
  list,
  current,
  onChangeList,
  handleListDropDownClick,
  handleModal,
}) => {
  const clickHandler = (list, e) => {
    e.stopPropagation();
    e.preventDefault();
    onChangeList(list);
    handleListDropDownClick();
  };

  return (
    <div
      role="button"
      tabIndex="0"
      onClick={e => clickHandler(list, e)}
      className={cn('pinned-list-option-wrapper', list.id === current?.id ? 'current-list' : null)}
      id="target"
    >
      <PinIcon list={list} />
      <div className="list-option-title">{list.title}</div>
      <div className="pinned-list-option-icon">
        <AddToFolder list={list} handleModal={handleModal} />
      </div>
    </div>
  );
};

PinnedListOption.propTypes = {
  list: propTypes.object,
  current: propTypes.object,
  onChangeList: propTypes.func,
  handleListDropDownClick: propTypes.func,
  dispatchUpdateList: propTypes.func,
  handleModal: propTypes.func,
  lowerSection: propTypes.bool,
};

export default PinnedListOption;
